interface AttachmentInterface {
    id: number;
    created: string;
    updated: string;
    height: number;
    width: number;
    path: string;
    hash: string;
    extension: string;
    type?: string;
    mimeType: string;
}

class Attachment implements AttachmentInterface {
    static readonly TYPE_NONE    = 'none';
    static readonly TYPE_GENERIC = 'generic';
    static readonly TYPE_CUSTOM  = 'custom';

    static readonly types: string[] = [
        Attachment.TYPE_NONE,
        Attachment.TYPE_GENERIC,
        Attachment.TYPE_CUSTOM
    ];

    id: number;
    created: string;
    updated: string;
    height: number;
    width: number;
    path: string;
    hash: string;
    extension: string;
    mimeType: string;
}

interface BlobInterface {
    content: string;
    encoding: string;
}

class Blob implements BlobInterface {
    content: string;
    encoding: string;
}

export {
    AttachmentInterface,
    Attachment,
    BlobInterface,
    Blob
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/attachments/api.models.ts